module.exports = __webpack_public_path__ + "img/mayotte.bb5bdbd.webp";